// SPDX-FileCopyrightText: 2025 Mercedes-Benz Group AG and Mercedes-Benz AG
//
// SPDX-License-Identifier: Apache-2.0

export const TOOLTIP_OPEN_DELAY_IN_MS = 500;
export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_FORMAT_SHORT = 'DD.MM.YYYY HH:mm';
export const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';
export const DATETIME_FORMAT_FILE = 'YYYY-MM-DD-HH-mm';
